<template>
    <div v-if="listNews.length>0">
        <section class="container-fluid py-0">
            <div
                class="d-flex align-items-center"
                :class="classTitle"
                v-if="title">
                <h2 class="content-title">{{ title }}</h2>
                <div class="view-more">
                    <router-link
                        v-if="viewMore"
                        :to="{name: 'portal.news.archive'}"
                        class="nav-link border-link">
                        {{ textMore }}
                    </router-link>
                </div>
            </div>
        </section>
        <section class="container-fluid news news--slider">
            <slider-control>
                <slide-element v-for="(news, index) in listNews" :key="index">
                    <news-card :news="news" />
                </slide-element>
            </slider-control>
        </section>
    </div>
</template>
<script>
import NewsCard from './NewsCard';
import SliderControl from '../slider/SliderControl.vue';
import SlideElement from '../slider/SlideElement.vue';
import mixin from '../../mixin';
import { formatString } from '@config/utils';


export default {
    components: {
        SliderControl,
        SlideElement,
        NewsCard,
    },
    mixins: [
        mixin
    ],
    props: {
        title: {
            type: String,
            default: null,
        },
        classTitle: {
            type: String,
            default: null,
        },
        viewMore: {
            type: Boolean,
            default: false,
        },
        textMore: {
            type: String,
            default: 'Ver mais',
        },
    },
    data() {
        return {
            pageID: 'news',
            listNews: [ ],
        }
    },
    mounted() {
        const url = this.url ? formatString(this.url.getLast, { locale: this.locale }) : null;
        if(url) {
            this.$http(url).then(({data}) => {
                this.listNews = data.data;
            });
        }
    },
}
</script>
